module.exports = __webpack_public_path__ + "media/images/muscleAction-0e5155799481a888443a9704947629d8.svg";